/**
 * AlmadarPostContextCompactionENAlmadarPostContextCompactionENPage
 *
 * Page component for AlmadarPostContextCompactionENAlmadarPostContextCompactionENPage
 * Path: /blog/context-compaction
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostContextCompactionENPostPageView as __AlmadarPostContextCompactionENPostPageView } from '@/components/traits/AlmadarPostContextCompactionENPostPageView';
import { AlmadarPostContextCompactionENPostAnalyticsView as __AlmadarPostContextCompactionENPostAnalyticsView } from '@/components/traits/AlmadarPostContextCompactionENPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostContextCompactionENAlmadarPostContextCompactionENPageProps {
  // Add any page-level props here
}

export function AlmadarPostContextCompactionENAlmadarPostContextCompactionENPage(_props: AlmadarPostContextCompactionENAlmadarPostContextCompactionENPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostContextCompactionENPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostContextCompactionENPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostContextCompactionENAlmadarPostContextCompactionENPage;
